import { createApp } from 'vue'
import "@/styles/app.css";
import 'swiper/swiper-bundle.css';
import App from './App.vue'
import "@fortawesome/fontawesome-free/css/all.min.css";
import router from './router';

const app = createApp(App);
app.use(router);
app.mount('#app');